import { ContentDelivery } from '@episerver/spa-core';
import { Box, CookieBanner as CookieBannerDDS } from '@norges-domstoler/dds-components';
import { General, useTranslation } from 'app/hooks/useTranslations';
import { useEffect, useState } from 'react';
import { getCookieConsent, setConsentCookie } from './utils';

interface CookieBannerProps {
    cookieBannerTitle: ContentDelivery.StringProperty;
    cookieBannerMainBody: ContentDelivery.StringProperty;
    language: string;
    forceShow?: boolean;
    onClose?: () => void;
}

export const CookieBanner = ({
    cookieBannerTitle,
    cookieBannerMainBody,
    language,
    forceShow = false,
    onClose,
}: CookieBannerProps) => {
    const { t } = useTranslation();
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        const consent = getCookieConsent();
        if (consent.remove_monsido_cookie === undefined) {
            setShowBanner(true);
        }
    }, []);

    useEffect(() => {
        if (forceShow) {
            setShowBanner(true);
        }
    }, [forceShow]);

    const handleConsent = (removeMonsido: boolean) => {
        setConsentCookie(removeMonsido);
        setShowBanner(false);
        onClose?.();
        const fn = removeMonsido
            ? (window as any)?.monsido_functions?.removeCookieConsent
            : (window as any)?.monsido_functions?.setCookieConsent;
        fn?.();
    };

    if (!cookieBannerTitle?.value || !showBanner) {
        return null;
    }

    return (
        <Box position="relative">
            <CookieBannerDDS
                position="fixed"
                style={{ zIndex: 100 }}
                description={
                    <div
                        className="xhtml-container-cookie-block"
                        dangerouslySetInnerHTML={{ __html: cookieBannerMainBody?.value }}
                    />
                }
                headerText={cookieBannerTitle?.value}
                buttons={[
                    {
                        children: t(`${General}.AcceptAll`, language),
                        onClick: () => handleConsent(false),
                    },
                    {
                        children: t(`${General}.OnlyNecessary`, language),
                        onClick: () => handleConsent(true),
                    },
                ]}
                bottom={{ xs: 'x0.25', sm: 'x0.5', md: 'x1', lg: 'x1.5', xl: 'x1.5' }}
                left={{ xs: 'x0.25', sm: 'x0.5', md: 'x1', lg: 'x2', xl: 'x2' }}
                right={{ xs: 'x0.25', sm: 'x0.5', md: 'x1', lg: 'x2', xl: 'x2' }}
            />
        </Box>
    );
};

export default CookieBanner;
